import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import IconUser from "../SvgIcons/IconUser";
import Sidebar from "../Sidebar";
import IconSignIn from "../SvgIcons/IconSignIn";
import ReactDOMServer from 'react-dom/server';
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import IconArrowLeft from "../SvgIcons/IconArrowLeft";
import GlobalLogo from "../SvgIcons/GlobalLogo";
import IconBar from "../SvgIcons/IconBar";
import IconClose from "../SvgIcons/IconClose";
export default function Header({ pageTitle, backTo }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const toggleUserInfo = () => {
    const username = localStorage.getItem("AdminUser_Name") || "User";
    const email = localStorage.getItem("email") || "Not Available";
    const contact = localStorage.getItem("contact") || "Not Available";
    const address = localStorage.getItem("address") || "Not Available";
    const iconHtml = ReactDOMServer.renderToStaticMarkup(<IconUser />);

    Swal.fire({
      html: `
        <div class="user-profile">
         ${iconHtml}       
          <div class="info">
           <p><strong>Name :</strong><span>${username}</span></p>
            <p><strong>Contact :</strong><span>${contact}</span></p>
            <p><strong>Email :</strong></strong><span>${email}</span></p>
            <p><strong>Address :</strong><span>${address}</span></p>                   
          </div>          
        </div>
      `,
      showConfirmButton: false, // Hide default "OK" button
      showCloseButton: true, // Show close (X) button
      customClass: {
        popup: "custom-swal",
        closeButton: "custom-close-btn",
      },
    });
  };

  const handleLogout = async () => {
    // First, show a confirmation dialog to ask the user if they are sure about logging out
    const result = await Swal.fire({
      // title: 'Are you sure?',
      text: "Are you sure you want to log out?",
      icon: "warning",
      showCancelButton: true, // Show the "No" button (Cancel)
      confirmButtonText: "Yes", // Text for the "Yes" button
      cancelButtonText: "No", // Text for the "No" button
      position: "center",
      reverseButtons: true, // Reverse the order of buttons, "Yes" left, "No" right
    });

    // If the user confirms the logout (clicks "Yes")
    if (result.isConfirmed) {
      try {
        // Clear local storage and session info
        localStorage.clear();
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("AdminUser_Name");
        // Prevent the user from going back to the previous authenticated pages
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = () => {
          window.history.pushState(null, "", window.location.href);
        };
        window.location.href = "/";

        // Optional: Show a success alert after logout
        Swal.fire({
          title: "Logged out!",
          text: "You have successfully logged out.",
          icon: "success",
          position: "center",
          showConfirmButton: false, // Hide confirm button
          timer: 7000, // Set the timer for success message
        });
        // Redirect to the login page (this can also be handled by window.location.href)
        navigate("/");
      } catch (error) {
        console.error("Logout error:", error);

        // Optionally, show an error message if something goes wrong
        Swal.fire(
          "Error!",
          "An error occurred while logging you out. Please try again.",
          "error"
        );
      }
    }
  };

  return (
    <section>
      <header className="header-top d-flex align-items-center justify-content-between">
        <div className="logosidebar d-flex align-items-center gap-5">
          <GlobalLogo />
          <button
            type="button"
            className="sidebar-toggle-btn"
            onClick={toggleSidebar}
            aria-label={sidebarOpen ? "Close menu" : "Open menu"}
          >
            {sidebarOpen ? <IconClose /> : <IconBar />}
          </button>
          <div className="page-title d-flex align-items-center">
            {backTo && (
              <Link to={backTo} className="btn backbtn">
                <IconArrowLeft />
                Back
              </Link>
            )}
            <h2>{pageTitle}</h2>
          </div>
        </div>

        <div className="user-area">
          <button className="logout btn btn-purpal" onClick={handleLogout}>
            <IconSignIn /> Logout
          </button>
          <div className="user-container">
            {/* User Icon to Toggle Info */}
            <Link to="#" className="usericon" onClick={toggleUserInfo}>
              <IconUser />
            </Link>
          </div>
        </div>
      </header>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
    </section>
  );
}
